import { SlideHeader, Headline } from "../shared";

export function Slide12Business() {
  const STAGES = [
    { stage: "Now", revenue: "Device sales, direct and co-branded.", proof: "Target: $49 retail, under $12 unit cost, about 75% gross margin." },
    { stage: "Next", revenue: "Formulation refills and brand licensing.", proof: "30% of buyers purchase a refill within 90 days." },
    { stage: "Parallel", revenue: "Clinical collaboration and medical licensing.", proof: "Medical aesthetics and dermatology partners exploring adherence pilots and brand or technology licensing." },
    { stage: "Later", revenue: "Personalized digital services.", proof: "Whether connected features keep people applying." },
  ];
  return (
    <div className="max-w-3xl" data-testid="pitch-slide-business">
      <SlideHeader n="13" label="Business Model" />
      <Headline>
        Devices first. <span className="text-accent">Recurring revenue next.</span>
      </Headline>
      <div className="mt-6 space-y-4 max-w-2xl" data-testid="pitch-business-stages">
        {STAGES.map((s) => (
          <div key={s.stage} className="flex gap-5 border-l-2 border-accent/40 pl-5 py-1">
            <span className="font-mono text-xs tracking-[0.15em] uppercase text-accent w-20 shrink-0 pt-0.5">{s.stage}</span>
            <div>
              <p className="font-body text-white text-base md:text-lg font-medium">{s.revenue}</p>
              <p className="font-body text-zinc-500 text-sm leading-relaxed mt-1">{s.proof}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
